import { render, staticRenderFns } from "./ParticipantsMailing.vue?vue&type=template&id=0af749c8&"
import script from "./ParticipantsMailing.vue?vue&type=script&lang=js&"
export * from "./ParticipantsMailing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports